import { render } from "./PosterRenderer.vue?vue&type=template&id=53754e38"
import script from "./PosterRenderer.vue?vue&type=script&lang=js"
export * from "./PosterRenderer.vue?vue&type=script&lang=js"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__